/******/ (() => { // webpackBootstrap
/* eslint-disable */
function formatMoney(cents, format) {
  const moneyFormat = format || '${{amount}}';
  const normalizedCents = typeof cents === 'string' ? cents.replace('.', '') : cents;
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    const safePrecision = precision == null ? 2 : precision;
    const safeThousands = thousands || ',';
    const safeDecimal = decimal || '.';

    if (Number.isNaN(number) || number == null) return '0';

    const fixed = (number / 100).toFixed(safePrecision);
    const parts = fixed.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${safeThousands}`);
    const centsAmount = parts[1] ? safeDecimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }

  const match = moneyFormat.match(placeholderRegex);
  if (!match) return formatWithDelimiters(normalizedCents, 2);

  let value = '';
  switch (match[1]) {
    case 'amount':
      value = formatWithDelimiters(normalizedCents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(normalizedCents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(normalizedCents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(normalizedCents, 0, '.', ',');
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(normalizedCents, 2, ' ', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(normalizedCents, 2, "'", '.');
      break;
    default:
      value = formatWithDelimiters(normalizedCents, 2);
  }

  return moneyFormat.replace(placeholderRegex, value);
}

if (!customElements.get('free-shipping-progress')) {
  customElements.define(
    'free-shipping-progress',
    class FreeShippingProgress extends HTMLElement {
      constructor() {
        super();
        this.cartTotal = 0;
        this.onCartUpdated = this.onCartUpdated.bind(this);
        this.refresh = this.refresh.bind(this);
      }

      connectedCallback() {
        this.messageEl = this.querySelector('[data-ship-message]');
        this.fillEl = this.querySelector('[data-ship-fill]');
        this.trackEl = this.querySelector('[data-ship-track]');
        this.threshold = parseInt(this.dataset.threshold, 10) || 0;
        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
        this.progressTemplate = this.dataset.progressMessage || 'Spend [amount] more to get free shipping';
        this.successMessage = this.dataset.successMessage || "You've unlocked free shipping!";
        this.boldAmount = this.dataset.boldAmount === 'true';
        this.hideWhenQualified = this.dataset.hideWhenQualified === 'true';

        this.attachListeners();
        this.refresh();
      }

      disconnectedCallback() {
        if (!window.eventBus) return;
        window.eventBus.off('cart:added', this.onCartUpdated);
        window.eventBus.off('update:cart:drawer', this.onCartUpdated);
      }

      attachListeners() {
        if (!window.eventBus) return;
        window.eventBus.on('cart:added', this.onCartUpdated);
        window.eventBus.on('update:cart:drawer', this.onCartUpdated);
      }

      onCartUpdated() {
        this.refresh();
      }

      async refresh() {
        await this.fetchCart();
        this.updateUI();
      }

      async fetchCart() {
        try {
          const response = await fetch('/cart.js');
          if (!response.ok) throw new Error('Cart fetch failed');
          const cart = await response.json();
          this.cartTotal = cart.total_price || 0;
        } catch (error) {
          console.error('Free shipping progress: unable to load cart', error);
        }
      }

      updateUI() {
        if (!this.threshold) return;

        const total = this.cartTotal;
        const remaining = Math.max(this.threshold - total, 0);
        const progress = Math.min(Math.round((total / this.threshold) * 100), 100);
        const qualified = total >= this.threshold;

        if (qualified && this.hideWhenQualified) {
          this.hidden = true;
          return;
        }

        this.hidden = false;

        if (this.fillEl) this.fillEl.style.width = `${progress}%`;
        if (this.trackEl) {
          this.trackEl.setAttribute('aria-valuenow', String(progress));
          this.trackEl.setAttribute('aria-label', qualified ? 'Free shipping unlocked' : `${progress}% toward free shipping`);
        }

        if (!this.messageEl) return;

        if (qualified) {
          this.messageEl.innerHTML = this.successMessage;
          return;
        }

        const amountText = formatMoney(remaining, this.moneyFormat);
        const amountMarkup = this.boldAmount ? `<strong>${amountText}</strong>` : amountText;
        this.messageEl.innerHTML = this.progressTemplate
          .replace(/\[amount\]/gi, amountMarkup)
          .replace(/\{\{\s*amount\s*\}\}/gi, amountMarkup);
      }
    }
  );
}
/******/ })();
